import apiClient from '@/utils/request'
import {
  ISpotsPayload,
  ISpotsResponse
} from '@/apps/traforama/interfaces/spots'
import { nestedQueryFormatter } from '@/utils/query'

export const fetchItems = async (
  payload: ISpotsPayload
): Promise<ISpotsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.get<ISpotsResponse>('/spots', { params })
  return response.data
}

export const searchSpots = async (
  payload: ISpotsPayload
): Promise<ISpotsResponse> => {
  const params = Object.assign(
    { limit: payload.limit, start: payload.start },
    nestedQueryFormatter('filter', payload.filter)
  )
  const response = await apiClient.post<ISpotsResponse>('/spots/search', null, {
    params
  })
  return response.data
}

export const checkSuitableCampaigns = async (
  id: string
): Promise<ISpotsResponse> => {
  const response = await apiClient.get<ISpotsResponse>(
    `/spots/${id}/suitable_campaigns`
  )
  return response.data
}
